function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M9.6 4.4l-1.8-1c-.2-.1-.4-.1-.6 0-.2.1-.3.3-.3.5v.7H5.5V3.3c0-.8-.7-1.4-1.5-1.3h-.9v-.4c0-.1 0-.1-.1-.1l-.1-.1H.2c-.1-.1-.2 0-.2.1v1.9c0 .1.1.2.2.2h2.7c.1 0 .1 0 .1-.1l.1-.1V3H4c.3 0 .5.2.5.3v3.5c0 .2-.2.3-.5.3h-.9v-.5c0-.1 0-.1-.1-.1l-.1-.1H.2c-.1 0-.1 0-.1.1-.1 0-.1.1-.1.1v1.8c0 .1 0 .1.1.1l.1.1h2.7c.1 0 .1 0 .1-.1l.1-.1v-.3H4c.8.1 1.5-.5 1.5-1.3V5.5h1.4v.7c0 .2.1.4.3.5s.4.1.6 0l1.9-1.1c.2-.1.3-.3.3-.6s-.1-.4-.4-.6z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10"
  }, props), _ref);
};

export default SvgComponent;